module.exports = __webpack_public_path__ + "TB_Eating_Ambience_A.wav.034bd3c6.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/eating/TB_Eating_Ambience_A.wav.mp3
// module id = 490
// module chunks = 0